<template>
  <t-filter-wrapper :label="$t('fields.tenant')">
    <tenant-select
      :value="value"
      multiple
      @input="$emit('input', $event)"
      @change="$emit('change', $event)"
    />
  </t-filter-wrapper>
</template>

<script>
import TenantSelect from '~/components/ResourceSelect/TenantSelect';

export default {
  components: {
    TenantSelect,
  },

  props: {
    value: {
      type: Array,
      required: false,
      default: () => [],
    },
  },
};
</script>
